import { render, staticRenderFns } from "./companyWkrDetails.vue?vue&type=template&id=6ff867df&"
import script from "./companyWkrDetails.vue?vue&type=script&lang=js&"
export * from "./companyWkrDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports